import dayjs from "dayjs";
import type { CustomerDTO } from "@ifa/utils";

export const maskIdNumber = (id?: string) => {
  if (!id) return "--";
  if (id.length <= 8) return id;
  const start = id.slice(0, 3);
  const end = id.slice(-4);
  return `${start}****${end}`;
};

export const deriveAge = (customer: CustomerDTO) => {
  if (customer.age !== undefined && customer.age !== null) return customer.age;
  if (customer.birthDate) {
    return dayjs().diff(dayjs(customer.birthDate), "year");
  }
  return undefined;
};

export const formatDateTime = (value?: string) => {
  if (!value) return "--";
  return dayjs(value).format("YYYY-MM-DD HH:mm");
};

export const resolveCustomerKey = (customer: CustomerDTO) => {
  if (customer.id) return customer.id;
  if (customer.idNumber) return customer.idNumber;
  return `${customer.ChineseName ?? ""}-${customer.englishName ?? ""}-${customer.updateTime ?? ""}`;
};
